// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3KpJS","left":"styles_left__3wT09"};